import { Stack } from "@comet/admin";
import PageTitle from "@src/components/headers/PageTitle";
import { FormattedMessage } from "react-intl";

import CamerasSummary from "./DevicesSummary";
import SimCardsSummary from "./SimCardsSummary";
import UsersSummary from "./UsersSummary";

export default () => {
    return (
        <Stack topLevelTitle={<FormattedMessage id="reviermanager.page.dashboard" defaultMessage="Dashboard" />}>
            <PageTitle>
                <FormattedMessage id="reviermanager.page.dashboard" defaultMessage="Dashboard" />
            </PageTitle>
            <SimCardsSummary />
            <CamerasSummary />
            <UsersSummary />
        </Stack>
    );
};
